/* global TimelineMax PIXI */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import createSprite from '../../../lib/createSprite';
import Utils from '../../../lib/utils';
import InvertFilter from '../../../lib/InvertFilter';

const propTypes = {
    index: PropTypes.number,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    border: PropTypes.number,
    objs: PropTypes.object,
    container: PropTypes.object,
    focus: PropTypes.bool,

    backgroundKey: PropTypes.string,
    layers: PropTypes.array,

    bottomTile: PropTypes.bool,
    bottomTileColor: PropTypes.string,

    fullWidth: PropTypes.number.isRequired,
    fullHeight: PropTypes.number.isRequired,
};

const defaultProps = {
    layers: [],
    bottomTile: true,
    bottomTileColor: 'gray',
};

const contextTypes = {
    crisis: React.PropTypes.bool,
};

class Background extends Component {

    constructor(props) {
        super(props);

        this.sprite = null;
        this.tilingSprite = null;

        this.layers = [];

        this.addSprite = this.addSprite.bind(this);
        this.resize = this.resize.bind(this);
    }

    componentDidMount() {
        const {
            container,
            backgroundKey,
            width,
            height,
            index,
            border,
            layers,
            bottomTile,
            bottomTileColor,
        } = this.props;

        const context = this.context;
        const obj = _.get(this.props, `objs.${backgroundKey}`);
        const sprite = createSprite(obj);
        this.sprite = sprite;
        const size = Utils.getSizeWithinMax(sprite.width, sprite.height, width, height);

        sprite.width = size.width;
        sprite.height = size.height;
        sprite.name = `background${index}`;
        sprite.x = index * (sprite.width + border);

        container.addChild(sprite);

        // Add extras
        layers.forEach(this.addSprite);

        if (bottomTile === true) {
            this.addBottomTile(bottomTileColor);
        }

        if (context.crisis) {
            this.startCrisis();
        } else {
            this.stopCrisis();
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const crisisChanged = prevContext.crisis !== this.context.crisis;
        const sizeChanged = prevProps.fullWidth !== this.props.fullWidth
            || prevProps.fullHeight !== this.props.fullHeight;

        if (crisisChanged && this.props.focus) {
            if (this.context.crisis) {
                this.startCrisis();
            } else {
                this.stopCrisis();
            }
        }

        if (sizeChanged) {
            this.resize();
        }
    }

    componentWillUnmount() {
        this.props.container.removeChild(this.sprite);
        this.sprite = null;
    }

    addSprite(layer) {
        const { container, width, height, index, border } = this.props;

        const obj = _.get(this.props, `objs.${layer.backgroundKey}`);
        const sprite = createSprite(obj);
        const size = Utils.getSizeWithinMax(sprite.width, sprite.height, width, height);

        sprite.width = size.width;
        sprite.height = size.height;
        sprite.name = `backgroundLayer${index}${layer.backgroundKey}`;
        sprite.x = index * (sprite.width + border);

        container.addChild(sprite);
        this.layers.push(sprite);
    }

    addBottomTile(color) {
        const { container, width, height, fullHeight, index, border } = this.props;

        const obj = _.get(this.props, `objs.${color}Tile`);

        if (fullHeight > height) {
            const tilingSprite = new PIXI.extras.TilingSprite(
                obj.texture,
                width,
                fullHeight - height,
            );
            tilingSprite.x = index * (width + border);
            tilingSprite.y = height;
            // tilingSprite.scale = 0.5;
            this.tilingSprite = tilingSprite;
            container.addChild(tilingSprite);
        }

        // const sprite = createSprite(obj);
        // console.log(this.props.objs, obj);
        // const maxY = Math.max(height, fullHeight);

        // const size = Utils.getSizeWithinMax(sprite.width, sprite.height, width, height);
        // sprite.width = 256;
        // sprite.height = 256;
        // sprite.name = `tile-${index}-${color}`;
        // sprite.x = 200;
        // sprite.y = 200; // maxY;
        // sprite.x = index * (sprite.width + border);
        //
        // container.addChild(sprite);
        // this.layers.push(sprite);
        //
        // console.log('hello');
    }

    resize() {
        const {
            fullWidth,
            height,
            fullHeight,
            border,
            index,
        } = this.props;

        if (this.tilingSprite !== null) {
            if (fullHeight > height) {
                // console.log('wu', this.props.scale, fullHeight, height);
                this.tilingSprite.width = fullWidth;
                this.tilingSprite.height = fullHeight - height;
                this.tilingSprite.x = index * (fullWidth + border);
                this.tilingSprite.y = height;
            }
        }
    }

    startCrisis() {
        const background = this.sprite;

        const filter = new InvertFilter();
        background.filters = null;

        const timeline = new TimelineMax();

        function updateFilter() {
            if (background.filters === null) {
                background.filters = [filter];
            } else {
                background.filters = null;
            }
        }

        function removeFilter() {
            background.filters = null;
        }

        timeline.to({}, 0.06, {
            repeat: 2,
            onStart: updateFilter,
            onRepeat: updateFilter,
            onComplete: removeFilter,
        });

        timeline.to({}, 0.06, {
            repeat: 2,
            onStart: updateFilter,
            onRepeat: updateFilter,
            onComplete: removeFilter,
        }, `+=${_.random(0.8, 1, true)}`);

        timeline.to({}, 0.05, {
            repeat: 4,
            onStart: updateFilter,
            onRepeat: updateFilter,
            onComplete: removeFilter,
        }, `+=${_.random(0.4, 0.6, true)}`);

        timeline.to({}, 0.04, {
            repeat: 6,
            onStart: updateFilter,
            onRepeat: updateFilter,
            onComplete: removeFilter,
        }, `+=${_.random(0.7, 0.9, true)}`);
    }

    stopCrisis() {
        this.sprite.filters = null;
    }

    render() {
        return (
            <div className="frame-background">
                <div className="frame-background-footer" />
            </div>
        );
    }
}

Background.propTypes = propTypes;
Background.defaultProps = defaultProps;
Background.contextTypes = contextTypes;

module.exports = Background;



// WEBPACK FOOTER //
// ./js/components/frames/_common/Background.jsx